import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import { useEffect, useState } from "react";
import { spaceBetween } from "../../../../../common/util/Array/spaceBetween";
import { fetchPost } from "../../../../../common/util/fetch";
import { fetchSetMuteStatus } from "./fetchSetMuteStatus";

export function MuteSwitch({
    fromUserId,
    targetUserId,
}: {
    fromUserId: number;
    targetUserId: number;
}) {
    const [checked, setChecked] = useState(false);
    const toggleChecked = () => {
        setChecked(!checked);
        fetchSetMuteStatus(fromUserId, targetUserId, !checked).then(m => {
            setChecked(m);
        });
    };

    useEffect(() => {
        fetchGetMuteStatus(fromUserId, targetUserId).then(muted => {
            setChecked(muted);
        });
    }, []);

    const c = useStyles();

    return (
        <div className={c.container}>
            <span className={spaceBetween(c.message, checked ? "red" : c.grey)}>
                {checked ? "You won't receive message alerts" : "Mute User"}
            </span>

            <Switch
                size="small"
                checked={checked}
                onChange={toggleChecked}
                color="primary"
            />
        </div>
    );
}
const useStyles = makeStyles(theme => ({
    container: {
        position: "absolute",
        top: 0,
        right: 5,
        height: 38,
        display: "flex",
        alignItems: "center",
    },
    message: {
        marginRight: 1,
        fontSize: "small",
    },
    grey: {
        color: theme.palette.grey[700],
    },
}));

async function fetchGetMuteStatus(
    fromUserId: number,
    targetUserId: number
): Promise<boolean> {
    const result = await fetchPost<
        {
            fromUserId: number;
            targetUserId: number;
        },
        boolean
    >("api/Message/GetMuteStatus", { fromUserId, targetUserId });
    if (typeof result === "boolean") {
        return result;
    }
    return false;
}

